(function () {
  'use strict';

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const toggle = document.querySelector('[href="#cart-drawer"], [data-drawer-id="cart-drawer"], cart-drawer-component dialog');
    if (toggle) toggle.click();
  }

  function dispatchCartUpdate(cart) {
    const event = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        data: {
          itemCount: cart.item_count,
        },
      },
    });
    document.dispatchEvent(event);
  }

  async function quickAdd(btn) {
    const variantId = btn.dataset.variantId;
    const hasVariants = btn.dataset.hasVariants === 'true';
    const productUrl = btn.dataset.productUrl;

    if (hasVariants) {
      window.location.href = productUrl;
      return;
    }

    if (!variantId || btn.disabled || btn.dataset.loading) return;

    btn.dataset.loading = '1';
    const original = btn.innerHTML;
    btn.innerHTML = '&#8942;';

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!addRes.ok) throw new Error('add-failed');

      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();

      dispatchCartUpdate(cart);
      openCartDrawer();

      btn.innerHTML = '&#10003;';
      btn.classList.add('dayum-qa-btn--added');

      setTimeout(() => {
        btn.innerHTML = original;
        btn.classList.remove('dayum-qa-btn--added');
        delete btn.dataset.loading;
      }, 1600);
    } catch {
      btn.innerHTML = original;
      delete btn.dataset.loading;
    }
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.dayum-qa-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    quickAdd(btn);
  });
})();
